declare var window: any;
export class AppUtils {
  static getUrlParams() {
		window.params = new URLSearchParams(window.location.search);
		if(window.params){
			return AppUtils.objectify(Array.from(window.params));
		}
		return {};
	}
	static objectify(array) {
		return array.reduce((p, c) => {
			p[c[0]] = c[1];
			return p;
		}, {});
	}
	static encodeURI(uri: any) {
		return encodeURIComponent(JSON.stringify(uri));
	}

	/**
	   * Custom async setTimeOut for waiting end of exe
	   */
	static async timeOut(ms: any, callback: any = null) {
		return new Promise<void>(resolve =>
			setTimeout(() => {
				if (callback) {
					callback();
				}
				resolve();
			}, ms)
		);
	}
	static insertAndShift(arr: Array<any>, from: number, to: number) {
		let cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
		arr.splice(to, 0, cutOut);            // insert it at index 'to'
	}

	static decodeHTMLEntities(text: string) {
		var textArea = document.createElement('textarea');
		textArea.innerHTML = text;
		return textArea.value;
	}
}
